<table class="table-primary">
  <thead>
  <tr>
    <th (click)="sortByColumn('friendlyName')" class="text-left sort drug" scope="col">
      Drug
      <img [class.asc]="tableColumns.friendlyName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('onHand')" class="text-right sort on-hand" scope="col">
      On-hand
      <img [class.asc]="tableColumns.onHand" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('lastActivity.createDate')" class="text-left sort activity" scope="col">
      Last Activity
      <img [class.asc]="tableColumns['lastActivity.createDate']" class="sort-icon"
           src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th class="text-right controls" scope="col">
      <!-- Controls -->
    </th>
  </tr>
  </thead>
  <tbody>
  <tr class="table-row"
      (click)="openSingleRecordTable(rowData)"
      *ngFor="let rowData of inventoryList"
  >
    <th class="text-left drug" scope="row">
      <div class="heading">
        {{rowData.friendlyName}}
      </div>
      <div class="secondary">
        {{rowData.packageNdc}}
      </div>
    </th>
    <td class="text-right on-hand">
      {{rowData.onHand | number}}
    </td>
    <td class="text-left activity">
      <app-badge [color]="(rowData | transactionBadge)?.color">
        {{(rowData | transactionBadge)?.label}}
      </app-badge>
      <div class="secondary">
        <div class="formatted-date">
          {{rowData?.lastActivity?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
        </div>
        <div class="name">
          <ng-container *ngIf="rowData.lastActivity && rowData.lastActivity.firstName">
            {{rowData.lastActivity.firstName}}
          </ng-container>
          <ng-container *ngIf="rowData.lastActivity && rowData.lastActivity.lastName">
            {{rowData.lastActivity.lastName[0]}}.
          </ng-container>
        </div>
      </div>
    </td>
    <td class="text-right controls">
      <button class="table-menu-btn"
              appMenu
              [placement]="'bottom-right'"
              [autoClose]="'outside'"
              [menuContent]="tableRowMenuContent"
              triggers="manual"
              #tableRowMenu="appMenu"
              (click)="tableRowMenu.toggle();$event.stopPropagation();"
      >
        <img src="assets/icons/icon-three-dots.svg" alt="table-row-menu"/>
      </button>
      <ng-template #tableRowMenuContent>
        <div class="menu-container primary">
          <div (click)="openUnArchiveDialog(rowData);tableRowMenu.close();$event.stopPropagation()"
               class="menu-item"
          >
            <div class="option">
              Un-Archive NDC
            </div>
          </div>
        </div>
      </ng-template>
    </td>
  </tr>
  </tbody>
</table>

<!-- UN-ARCHIVE NDC DIALOG -->
<app-warning-dialog [show]="showUnArchiveNDCDialog"
                    header="Are you sure you want to un-archive this NDC?"
                    description="You can always archive the drug again later on the Active tab."
                    acceptBtnText="Yes, un-archive this NDC"
                    (cancel)="closeUnArchiveNDCDialog()"
                    (next)="unArchiveNDC()"
></app-warning-dialog>

